/* eslint-disable max-statements */
/* eslint-disable max-params */
import React, {useCallback} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import withAuth from "../../shared/with-auth";
import { showWishlistPopup, fetchWishlistedCarsList, addOrRemoveFromWishlist, showPrioritizationModal, updateWishlistNote, setLastWishlistedCarId } from "../my-wishlist/actions";
import { showToast } from "../../shared/toast-message/actions";
import { desktopCleverTapEvent, trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import debounce from "../../../utils/helpers/debounce";
import { LOCAL_STORAGE_KEYS, NUMBER } from "../../../constants/app-constants";
import clevertapDetails from "../../../tracking/parser/clevertap-details";
import { CLEVERTAP_EVENT_MAP } from "../../../tracking/au.desktop-clevertap";
import { getItem } from "../../../utils/helpers/storage-crud";
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";

export default function withWishlist(Component) {
    const WithWishlist = (props) => {
        const {
            wishlistedCarsList,
            addOrRemoveFromWishlistConnect,
            secureToken,
            showToastConnect,
            detailsConfig,
            detailsContent,
            showPrioritizationModalConnect,
            showPersonaliseYourWishlistModal,
            setLastWishlistedCarIdConnect,
            desktopWishlistAdoption
        } = props;
        const isWishlistedCar = (carId) => {
            return (wishlistedCarsList || []).indexOf(carId) !== -1;
        };

        // eslint-disable-next-line max-params
        const onClickAddToWishList = (vehicleId, token, gtmFrom, {
            comingSoon,
            make,
            model,
            shortlist,
            callback = () => {},
            errorCallback = () => {},
            toastStyle,
            carStatus = {},
            showNotifyPopup
        } = {}) => {
            const shortListed = shortlist ? shortlist : !isWishlistedCar(vehicleId);
            let params = {shortListed, vehicleId, comingSoon, make, model};
            params = carStatus.comingSoon ? {...params, ...carStatus} : params;
            addOrRemoveFromWishlistConnect(token ? token : secureToken, params).then(async() => {
                if (shortListed) {
                    showToastConnect({
                        variant: "shadowGreen",
                        text: "Added to Wishlist",
                        ...(toastStyle && { toastStyle })
                    });
                    setLastWishlistedCarIdConnect(vehicleId);
                    const priorityClosedCount = getItem(LOCAL_STORAGE_KEYS.priorityClosedCount);
                    const isPriorityAdded = getItem(LOCAL_STORAGE_KEYS.PRIORITY_ADDED);
                    const desktopWishlistAdoptionVariant = getAbExpirementVariant(desktopWishlistAdoption, EXPERIMENT_TYPE.VARIANT_B) && desktopWishlistAdoption?.featureFlags?.prioritisationFlow;
                    if ((priorityClosedCount < NUMBER.TWO && desktopWishlistAdoptionVariant) || isPriorityAdded) {
                        showPrioritizationModalConnect(true);
                    }
                    await yieldToMain();
                    trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.WISHLIST_CTA_SELECTED, {eventLabel: `options ${gtmFrom}`});
                    const data = clevertapDetails(detailsContent, {prefix: "wishlist_", config: detailsConfig, shortListed, withCarAttributes: true});
                    desktopCleverTapEvent(CLEVERTAP_EVENT_MAP.WISHLIST_DONE, data);
                } else {
                    showToastConnect({
                        variant: "shadowRed",
                        text: "Removed from Wishlist",
                        ...(toastStyle && { toastStyle })
                    });
                    await yieldToMain();
                    trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.WISHLIST_CTA_DESELECTED, {eventLabel: `options ${gtmFrom}`});
                }
                callback(shortListed, showNotifyPopup);
            }).catch(errorCallback);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
        const debounceWishlist = useCallback(debounce(onClickAddToWishList, NUMBER.THREE_HUNDRED), [isWishlistedCar]);

        return (
            <Component
                {...props}
                isWishlistedCar={isWishlistedCar}
                onClickAddToWishList={debounceWishlist}
                showPersonaliseYourWishlistModal={showPersonaliseYourWishlistModal}
                showPrioritizationModalConnect={showPrioritizationModalConnect}
            />
        );
    };

    WithWishlist.propTypes = {
        showWishlistPopupConnect: PropTypes.func,
        fetchWishlistedCarsListConnect: PropTypes.func,
        wishlistedCarsList: PropTypes.array,
        addOrRemoveFromWishlistConnect: PropTypes.func,
        secureToken: PropTypes.string,
        showToastConnect: PropTypes.func,
        detailsConfig: PropTypes.object,
        detailsContent: PropTypes.object,
        showPrioritizationModalConnect: PropTypes.func,
        showPersonaliseYourWishlistModal: PropTypes.bool,
        setLastWishlistedCarIdConnect: PropTypes.func,
        desktopWishlistAdoption: PropTypes.object
    };

    const mapStateToProps = ({
        myWishlist: { wishlistedCarsList, showPersonaliseYourWishlistModal },
        carDetails: {config: detailsConfig, content: detailsContent},
        abExperiment: {desktopWishlistAdoption}  }) => {
        return { wishlistedCarsList, detailsConfig, detailsContent, showPersonaliseYourWishlistModal, desktopWishlistAdoption};
    };

    const mapDispatchToProps = (dispatch) => bindActionCreators({
        showWishlistPopupConnect: showWishlistPopup,
        fetchWishlistedCarsListConnect: fetchWishlistedCarsList,
        addOrRemoveFromWishlistConnect: addOrRemoveFromWishlist,
        showToastConnect: showToast,
        showPrioritizationModalConnect: showPrioritizationModal,
        updateWishlistNoteConnect: updateWishlistNote,
        setLastWishlistedCarIdConnect: setLastWishlistedCarId
    }, dispatch);
    return connect(mapStateToProps, mapDispatchToProps)(
        withAuth(WithWishlist)
    );
}
